import {defineStore} from 'pinia';

export const useTitle = defineStore('title', {
  state: () => ({pTitle: undefined}),
  getters: {
    title: (state) => state.pTitle,
  },
  actions: {
    setTitle(_title) {
      this.pTitle = _title;
    },
  },
});
